// centralize the logic for display decimals with no limits
export const getCommonDisplayDecimals = (decimalPlace: number) => {
  return Number(decimalPlace);
};
